export default __webpack_public_path__ + "static/media/login-bg.ff7825f7.webp";